import { useEffect, useState } from 'react';

/**
 * useDebouncedValue — returns a value that only updates after `delay`ms
 * of quiet. Used to keep list filtering responsive without recomputing
 * on every keystroke.
 */
export default function useDebouncedValue(value, delay = 150) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
